import { Helmet } from "react-helmet-async";
import { useAuth } from "@/App";

const SEOHead = ({
  title = "FanVerse",
  description = "The ultimate fan wiki for fandom universes — Star Wars, Marvel, Lord of the Rings, and more.",
  image,
  url,
  type = "website",
}) => {
  const { user } = useAuth();
  const isAdmin = user && user.role === "admin";
  const baseTitle = title === "FanVerse" ? title : `${title} | FanVerse`;
  const fullTitle = isAdmin ? `ADMIN | ${baseTitle}` : baseTitle;
  const defaultImage = "https://static.prod-images.emergentagent.com/jobs/f60715c2-3b6b-4c99-a6c8-5c96b98e6cf9/images/53108f7d8ec9c28606e03e3c421e51fe4b80f13705cd9eeafc38c88182bd88ad.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={baseTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:site_name" content="FanVerse" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={baseTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />
    </Helmet>
  );
};

export default SEOHead;
